/**
 * Created by Gayratjon Rayimjonov on 5/24/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsService', StatsService);

    StatsService.$inject = ['$resource', 'DateUtils'];

    function StatsService ($resource, DateUtils) {
        var resourceUrl =  'api/stats-service';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        // data = angular.fromJson(data);
                        // data.registrationDate = DateUtils.convertDateTimeFromServer(data.registrationDate);
                    }
                    return data;
                }
            }
        });
    }
})();
